import i18next from 'i18next'

i18next.addResourceBundle('en', 'tags', {
    extensible: 'Extensible',
    nullable: 'Nullable',
    add_tag: 'Add Tag',
    tags: 'Tags',
    tag_type: 'Tag Type',
    actions: 'Actions',
    // Description
    tag_types_and_values: 'Tag Types and Values',
    tag_type_description: '<0>Tag type</0> is a category that includes tag values of the same group. For example, the Product tag type can include tags Auto, Life, and Home. <1>Proceed as follows:</1>',
    tag_type_instruction_p1: 'To add a tag type, in the <0>New Tag Type field</0>, enter the tag type name and press <0>Enter</0> or <0>Tab</0>. The tag type is added, and fields for tag values appear',
    tag_type_instruction_p2: 'To add a tag value, in the <0>New Tag</0> field, enter the tag name and press <0>Enter</0>',
    tag_type_auto_save_notice: 'All created tag types and values are saved automatically',
    tag_input_placeholder: 'New Tag Type',
    tags_from_a_project_name: 'Tags from a Project Name',
    tag_project_instruction_p1: 'Tags can be extracted from a project name using a project name template',
    tag_project_instruction_p2: 'Each template must be defined on its own line. The order of the templates is important: the first template has the highest priority, the last template has the lowest priority',
    tag_project_instruction_p3: 'Tag types are wrapped with the percentage \'%\' symbol',
    tag_project_instruction_p4: '\'?\' stands for any symbol',
    tag_project_instruction_p5: '\'*\' stands for any text of any length',
    example: 'Example',
    example_template: 'For the <0>%Domain%-%LOB%-*</0> template, for the <0>Policy-L&A-rules</0> project, the tags are <0>Policy</0> for the <0>Domain</0> tag type and <0>L&A</0> for <0>LOB</0>',
    project_name_templates: 'Project Name Templates',
    save_templates: 'Save Templates',
    fill_tags_for_project: 'Fill Tags for Project',
    templates_saved: 'Templates saved successfully',
    templates_save_error: 'Failed to save templates',
    fill_tags_success: 'Tags filled successfully for {{count}} project(s)',
    fill_tags_error: 'Failed to fill tags for projects',
    fill_preview: {
        title: 'Projects without tags',
        project_column: 'Project',
        tags_column: 'Tags',
        apply: 'Fill Tags',
        legend: 'A white tag is assigned as it is, a green one is created for its extensible tag type, '
            + 'a red one cannot be assigned, and a grey one is what the project carries now.',
        nothing_to_fill: 'Every project that matches a template already carries its tags.',
        not_modifiable: 'You do not have permission to change this project.',
        state: {
            assign: 'The value exists in the list of tags and is assigned to the project.',
            create: 'The value does not exist in the list of tags, and the tag type is extensible, '
                + 'so it is created and assigned to the project.',
            rejected: 'The value does not exist in the list of tags, and the tag type is not extensible, '
                + 'so it is neither created nor assigned, and the tag remains None.',
            keep: 'The project already carries this value.',
        },
    },
})
